module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#youtube",
      toString: function () {
        return this.url;
      }
    }